import type { Router } from "vue-router";
import { useUserStore } from "@/store/user";
import { usePayStore } from "@/store/pay";
import { useModelStore } from "@/store/model";
import { useRouteStore } from "@/store/route";
import { getViewName, handleStartOrEnterEventTracking } from "@/hooks/useEventTracking";
import { useLoginStore } from "@/store/login";
import { useTeamEditionStore } from "@/store/teamEdition";
import { registerMobileRedirectGuard } from "./guards/mobileRedirect";
function commonRouterHandle(router: Router) {
  router.afterEach((to) => {
    const payStore = usePayStore();

    payStore.ballParams.view = getViewName(to.name as string);
  });

  router.beforeEach(async (to, _from, next) => {
    const userStore = useUserStore();
    try {
      await userStore.synchronizeSharedAuthSession();
    } catch {
      next(false);
      return;
    }
    const modelStore = useModelStore();
    const loginStore = useLoginStore();
    loginStore.loginPopUpParams.login_position = `tab_${to.name as string}`;

    const routeStore = useRouteStore();
    routeStore.fromRouteName = _from.name as string;

    if (_from.name == "model") {
      modelStore.modelScrollTop = document.querySelector(".layout-content")?.scrollTop || 0;
    }

    if (to.meta.auth && !userStore.isLogin) {
      // 游客访问需登录页：弹登录框并重定向到工作台（保留 redirect 登录后回跳）
      // 注意：不能用 next(false) 中断，否则 vue-router 抛 Navigation aborted；重定向是正常导航
      loginStore.open = true;
      next({ name: "workbench", query: { redirect: to.fullPath } });
    } else if (to.meta.notTeamGroup && userStore.isGroupLogin) {
      // 禁止团队版用户进入
      next("/");
    } else if (to.meta.enterpriseOnly && !userStore.isEnterprise) {
      // 企业用户功能限制
      next("/403");
    } else {
      next();
    }
  });
}

function trackRouterHandle(router: Router) {
  router.beforeEach((to, from) => {
    if (typeof from.name === "undefined") {
      handleStartOrEnterEventTracking("$AppStart", to.name);
    }
  });

  // 曝光事件 enter
  router.afterEach((to, from) => {
    // 避免重复上报
    if (to.meta.group === "workspace" && to.query.layoutRefer && to.name == from.name) return;

    const routeStore = useRouteStore();
    // 当处于团队版本时， 需要带上_team标识 ,name 为powerDetails或者power时需要添加_team标识
    const teamEditionStore = useTeamEditionStore();
    const isTeamEdition = teamEditionStore.userType === "team";
    const name = isTeamEdition && ["powerDetails", "power"].includes(to.name as string) ? `${to.name as string}_team` : to.name;
    handleStartOrEnterEventTracking("enter", name as string);
    routeStore.currentRouteName = to.name as string;
  });
}

function routerHandle(router: Router) {
  registerMobileRedirectGuard(router);
  commonRouterHandle(router);
  trackRouterHandle(router);
}

export default routerHandle;
